export interface AnalyticsEntity {
	key: string;
	label: string;
	queryCode: string;
}

export interface AnalyticsGroup {
	key: string;
	label: string;
	reports: AnalyticsEntity[];
}

export const analyticsGroups: AnalyticsGroup[] = [
	{
		key: "billing_operations",
		label: "Billing Operations",
		reports: [
			{
				key: "plan_invoices_report",
				label: "Plan Invoices Report",
				queryCode: "plan_invoices_report",
			},
		],
	},
	{
		key: "operations_reports",
		label: "Operations Reports",
		reports: [
			{
				key: "dispense_report",
				label: "Dispense Report",
				queryCode: "dispense_report",
			},
			{
				key: "pap_report",
				label: "Pap Report",
				queryCode: "pap_report",
			},
			{
				key: "expiring_pap",
				label: "Expiring PAPs",
				queryCode: "expiring_pap",
			},
			{
				key: "approved_paps",
				label: "Approved PAPs",
				queryCode: "approved_paps",
			},
			{
				key: "recently_approved_paps",
				label: "PAP Dashboard",
				queryCode: "recently_approved_paps",
			},
			{
				key: "overrides_report",
				label: "Overrides",
				queryCode: "overrides_report",
			},
		],
	},
	{
		key: "census_report",
		label: "Census Report",
		reports: [
			{
				key: "census_report",
				label: "Census Report",
				queryCode: "census_report",
			},
		],
	},
];

export const analyticsEntities: AnalyticsEntity[] = analyticsGroups.flatMap(
	(group) => group.reports
);

export const getAnalyticsGroupForReport = (
	reportKey: string
): AnalyticsGroup | undefined =>
	analyticsGroups.find((group) =>
		group.reports.some((report) => report.key === reportKey)
	);

export const getDefaultAnalyticsReportKey = (): string =>
	analyticsGroups[0]?.reports[0]?.key ?? "";
